import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick}>
                <DataColumn kid='column1' name='name' fieldName='name' minWidth={300} maxWidth={600} align='left' />
                <DataColumn kid='column2' name='context' fieldName='context' minWidth={600} align='left' />
            </DataList>
        </>
    );
}